import "../../App.css";
import "./HeroImage.css";

const HeroImage = () => {
  return <div className="hero"></div>;
};

export default HeroImage;
